import { Form } from 'antd';

const AutoAcceptController = ({ children }) => {
  const autoAccept = Form.useWatch(['auto_accept']);
  return (
    children({ autoAccept })
  );
};

export default AutoAcceptController;